import { render, staticRenderFns } from "./CompanyReports.vue?vue&type=template&id=4e7cd4c9"
import script from "./CompanyReports.vue?vue&type=script&lang=js"
export * from "./CompanyReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CompanyReports.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingAnimation: require('/vercel/path0/components/ui/LoadingAnimation.vue').default,DisclosureCard: require('/vercel/path0/components/DisclosureCard.vue').default,InfoBox: require('/vercel/path0/components/InfoBox.vue').default})
